import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Badge from "../../components/common/Badge/Badge";
import TabsNavigation from "../../components/common/TabsNavigation/TabsNavigation";
import Table from "../../components/common/Table/Table";
import "./FichaGestor.scss";
import DetalleLayout from "../../Layouts/DetalleLayout/DetalleLayout";
import { useZone } from "../../context/ZoneContext";
import { getApiInstance } from "../../utils/api";
import { CiClock1 } from "react-icons/ci";
import { CgDanger } from "react-icons/cg";
import { CiCircleCheck } from "react-icons/ci";
import { formatDate } from "../../utils/utils";
import { addOrUpdateRecentItem } from "../../utils/utils";
import { mapList } from "../../utils/utils";

const formElementsDocumentos = [
    {
        elements: [
            {
                name: "tipoDocumento",
                type: "select",
                label: "Tipo de documento",
                placeholder: "Seleccione el tipo de documento",
                required: true,
                disabled: false,
                labelVisible: true,
                visible: true,
                options: [
                    {
                        value: "autorizacion_tratamiento",
                        label: "Autorización tratamiento residuos",
                    },
                    {
                        value: "licencia_actividad",
                        label: "Licencia de actividad",
                    },
                    {
                        value: "seguro_responsabilidad",
                        label: "Seguro de responsabilidad civil",
                    },
                    { value: "certificado_iso", label: "Certificado ISO" },
                    { value: "otros", label: "Otros" },
                ],
            },
            {
                name: "nombreArchivo",
                type: "text",
                label: "Nombre del archivo",
                placeholder: "Ingrese el nombre del archivo",
                required: true,
                disabled: false,
                labelVisible: true,
                visible: true,
            },
            {
                name: "fechaValidez",
                type: "text",
                label: "Fecha de validez (DD/MM/AAAA)",
                placeholder: "01/01/2024",
                required: true,
                disabled: false,
                labelVisible: true,
                visible: true,
            },
            {
                name: "fechaVencimiento",
                type: "text",
                label: "Fecha de vencimiento (DD/MM/AAAA)",
                placeholder: "31/12/2024",
                required: true,
                disabled: false,
                labelVisible: true,
                visible: true,
            },
            {
                name: "observaciones",
                type: "textarea",
                label: "Observaciones",
                placeholder: "Ingrese observaciones adicionales",
                required: false,
                disabled: false,
                labelVisible: true,
                visible: true,
                rows: 3,
            },
        ],
    },
];

export default function FichaGestor({ user }) {
    const { id } = useParams();
    const [gestor, setGestor] = useState(null);
    const [documentos, setDocumentos] = useState([]);
    const [tiposDocumentos, setTiposDocumentos] = useState([]);
    const [tarifas, setTarifas] = useState([]);
    const [activeTabGeneral, setActiveTabGeneral] = useState("informacion");
    const [activeTabDatos, setActiveTabDatos] = useState("documentacion");
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const { selectedZone } = useZone();

    useEffect(() => {
        if (gestor != null) {
            addOrUpdateRecentItem({
                id: gestor.codProveedor,
                title: gestor.nombre,
                type: "gestores",
            });
        }
    }, [gestor]);

    useEffect(() => {
        if (gestor != null) {
            addOrUpdateRecentItem({
                id: gestor.codProveedor,
                title: gestor.nombre,
                type: "gestores",
            });
        }
    }, [gestor]);

    const fetchGestor = async (id) => {
        try {
            const api = getApiInstance();
            console.log(`Fetching gestor with ID: ${id}`);
            const response = await api.get(
                `/api/Proveedores/GetProveedorById/${id}?codZona=${selectedZone.value}&codZonaLegal=1`
            );
            return await response.data;
        } catch (error) {
            console.error("Error fetching gestor:", error);
            throw error;
        }
    };

    const fetchDocumentos = async (id) => {
        try {
            const api = getApiInstance();
            const response = await api.get(
                `/api/GestorDocumentos/GetDocumentosFromGestor/${id}`
            );
            return await response.data;
        } catch (error) {
            console.error("Error fetching gestor:", error);
            throw error;
        }
    };

    const fetchTarifas = async (id) => {
        try {
            const api = getApiInstance();
            const response = await api.get(
                `/api/Tarifa/GetTarifasByProveedor/${id}`
            );
            return await response.data;
        } catch (error) {
            console.error("Error fetching gestor:", error);
            throw error;
        }
    };

    const fetchTiposDocumentos = async () => {
        try {
            // Productor = 1,
            // Gestor = 2,
            // Obra = 3,
            const api = getApiInstance();
            const response = await api.get(
                `/api/Documentos/GetTiposDocumentosByTipoEntidad/2/${selectedZone.value}`
            );
            return await response.data;
        } catch (error) {
            console.error("Error fetching tipos documentos:", error);
            throw error;
        }
    };

    useEffect(() => {
        const loadGestorData = async () => {
            try {
                setLoading(true);
                setError(null);

                const results = await Promise.allSettled([
                    fetchGestor(id),
                    fetchDocumentos(id),
                    fetchTarifas(id),
                    fetchTiposDocumentos(),
                ]);

                const [gestorRes, docRes, tarifaRes, tiposDocRes] = results;

                const gestorData =
                    gestorRes.status === "fulfilled" ? gestorRes.value : null;
                const documentosData =
                    docRes.status === "fulfilled" ? docRes.value : [];
                const tarifasData =
                    tarifaRes.status === "fulfilled" ? tarifaRes.value : [];
                const tiposDocumentosData =
                    tiposDocRes.status === "fulfilled" ? tiposDocRes.value : [];

                setGestor(gestorData);
                setDocumentos(documentosData);
                setTarifas(tarifasData);
                setTiposDocumentos([
                    ...mapList(
                        tiposDocumentosData,
                        "descripcion",
                        "codTipoDocumento"
                    ),
                ]);

                // opcional: si gestorRes rechazó por algo distinto a 404, mostrarlo
                if (gestorRes.status === "rejected") {
                    setError(
                        gestorRes.reason?.message || "Error al cargar gestor"
                    );
                }
            } catch (err) {
                console.error("Error cargando datos del gestor:", err);
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        if (id) loadGestorData();
    }, [id]);

    const getEstadoBadge = (estado) => {
        const estadoConfig = {
            VALIDADO: {
                type: "success",
                label: "Validado",
                Icon: CiCircleCheck,
            },
            PENDIENTE: { type: "info", label: "Pendiente", Icon: CiClock1 },
            INCIDENCIA: {
                type: "warning",
                label: "Incidencia",
                Icon: CgDanger,
            },
            VENCIDO: { type: "error", label: "Vencido", Icon: CgDanger },
            ACTIVA: { type: "success", label: "Activa", Icon: CiCircleCheck },
        };
        return estadoConfig[estado] || estadoConfig["PENDIENTE"];
    };

    const tabsGeneral = [
        { id: "informacion", label: "Información General" },
        { id: "localizacion", label: "Localización" },
    ];

    const tabsDatos = [
        { id: "documentacion", label: "Documentación" },
        { id: "tarifas", label: "Tarifas" },
    ];

    const renderInformacionGeneral = () => (
        <div className="ficha-gestor__info">
            <div className="ficha-gestor__field">
                <label>Nombre:</label>
                <span>{gestor.nombre}</span>
            </div>
            <div className="ficha-gestor__field">
                <label>CIF:</label>
                <span>{gestor.cif}</span>
            </div>
            <div className="ficha-gestor__field">
                <label>Contacto:</label>
                <span>{gestor.contacto}</span>
            </div>
            <div className="ficha-gestor__field">
                <label>Teléfono:</label>
                <span>{gestor.telefono}</span>
            </div>
            <div className="ficha-gestor__field">
                <label>Email:</label>
                <span>{gestor.email}</span>
            </div>
            <div className="ficha-gestor__field">
                <label>Tipo:</label>
                <span>{gestor.tipo}</span>
            </div>
            <div className="ficha-gestor__field">
                <label>Estado:</label>
                <span className="ficha-gestor__field-badge">
                    <Badge
                        variant={getEstadoBadge(gestor.codEstado).type}
                        Icon={getEstadoBadge(gestor.codEstado).Icon}
                    >
                        {getEstadoBadge(gestor.codEstado).label}
                    </Badge>
                </span>
            </div>
        </div>
    );

    const renderLocalizacion = () => (
        <div className="ficha-gestor__info">
            <div className="ficha-gestor__field">
                <label>Dirección:</label>
                <span>{gestor.direccion}</span>
            </div>
            <div className="ficha-gestor__field">
                <label>Localidad:</label>
                <span>{gestor.localidad}</span>
            </div>
            <div className="ficha-gestor__field">
                <label>Código postal:</label>
                <span>{gestor.codigoPostal}</span>
            </div>
            <div className="ficha-gestor__field">
                <label>Provincia:</label>
                <span>{gestor.provincia}</span>
            </div>
            <div className="ficha-gestor__field">
                <label>Comunidad:</label>
                <span>{gestor.comunidad}</span>
            </div>
            <div className="ficha-gestor__field">
                <label>País:</label>
                <span>{gestor.pais}</span>
            </div>
        </div>
    );

    const renderGeneralContent = () => {
        switch (activeTabGeneral) {
            case "informacion":
                return renderInformacionGeneral();
            case "localizacion":
                return renderLocalizacion();
            default:
                return renderInformacionGeneral();
        }
    };

    const renderDatosContent = () => {
        switch (activeTabDatos) {
            case "documentacion":
                return (
                    <div className="ficha-gestor__documentacion">
                        <Table
                            columns={[
                                {
                                    key: "tipoDocumento",
                                    label: "Tipo de documento",
                                    visible: true,
                                    sortable: true,
                                },
                                {
                                    key: "documento",
                                    label: "Documento",
                                    visible: true,
                                    sortable: true,
                                    type: "document",
                                    documentProp: "ficheroBase64",
                                },
                                {
                                    key: "validez",
                                    label: "Validez",
                                    visible: true,
                                    sortable: true,
                                    render: (row) =>
                                        `${formatDate(
                                            row.fechaIni
                                        )} - ${formatDate(row.fechaFin)}`,
                                },
                                {
                                    key: "codEstado",
                                    label: "Validación",
                                    visible: true,
                                    sortable: true,
                                },
                            ]}
                            dataTable={documentos}
                            keyProp="codDocumento"
                            noResultsMessage="No hay documentos disponibles"
                            rowsPerPage={10}
                            showCheckboxes={false}
                            actions={["Eliminar"]}
                            elementName="Documento"
                            stateProp="codEstado"
                            states={[
                                { type: "primary", label: "", Icon: null },
                                {
                                    type: "info",
                                    label: "Pendiente de validar",
                                    Icon: CiClock1,
                                },
                                {
                                    type: "warning",
                                    label: "Validación con incidencias",
                                    Icon: CgDanger,
                                },
                                {
                                    type: "success",
                                    label: "Validado",
                                    Icon: CiCircleCheck,
                                },
                            ]}
                            stateChangeOptions={[
                                { value: "1", label: "Pendiente de validar" },
                                {
                                    value: "2",
                                    label: "Validación con incidencias",
                                },
                                { value: "3", label: "Validado" },
                            ]}
                            stateChangeUrl="/api/Validaciones/SetValidacion"
                            formElements={formElementsDocumentos}
                            addApiUrl="/api/GestorDocumentos/SetDocumento"
                            deleteApiUrl="/api/GestorDocumentos/DeleteDocumento"
                            loading={loading}
                            userCodAcceso={Number(user.codAcceso)}
                            userCodPerfil={Number(user.role)}
                        />
                    </div>
                );
            case "tarifas":
                return (
                    <div className="ficha-gestor__tarifas">
                        <Table
                            columns={[
                                {
                                    key: "tipoResidue",
                                    label: "Tipo de residuo",
                                    visible: true,
                                    sortable: true,
                                },
                                {
                                    key: "precio",
                                    label: "Precio",
                                    visible: true,
                                    sortable: true,
                                },
                                {
                                    key: "vigencia",
                                    label: "Vigencia",
                                    visible: true,
                                    sortable: true,
                                },
                                {
                                    key: "codEstado",
                                    label: "Estado",
                                    visible: true,
                                    sortable: true,
                                },
                            ]}
                            dataTable={tarifas}
                            noResultsMessage="No hay tarifas disponibles"
                            rowsPerPage={10}
                            showCheckboxes={false}
                            actions={["Editar", "Eliminar"]}
                            elementName="Tarifa"
                            stateProp="codEstado"
                            states={[
                                { type: "primary", label: "", Icon: null },
                                {
                                    type: "info",
                                    label: "Pendiente de validar",
                                    Icon: CiClock1,
                                },
                                {
                                    type: "warning",
                                    label: "Validación con incidencias",
                                    Icon: CgDanger,
                                },
                                {
                                    type: "success",
                                    label: "Validado",
                                    Icon: CiCircleCheck,
                                },
                            ]}
                            formElements={[
                                {
                                    elements: [
                                        {
                                            name: "codProveedor",
                                            type: "text",
                                            required: true,
                                            disabled: false,
                                            visible: false,
                                            defultValue: `${id}`,
                                        },
                                        {
                                            name: "proveedores",
                                            type: "text",
                                            required: true,
                                            disabled: false,
                                            visible: false,
                                            defultValue: `${gestor.nombre}`,
                                        },
                                        {
                                            name: "fechaInicio",
                                            type: "text",
                                            label: "Fecha de inicio (DD/MM/AAAA)",
                                            placeholder: "01/01/2024",
                                            required: true,
                                            disabled: false,
                                            labelVisible: true,
                                            visible: true,
                                        },
                                        {
                                            name: "fechaFin",
                                            type: "text",
                                            label: "Fecha de fin (DD/MM/AAAA)",
                                            placeholder: "31/12/2024",
                                            required: true,
                                            disabled: false,
                                            labelVisible: true,
                                            visible: true,
                                        },
                                        {
                                            name: "descr",
                                            type: "textarea",
                                            label: "Descripción",
                                            placeholder:
                                                "Ingrese una descripción",
                                            required: false,
                                            disabled: false,
                                            labelVisible: true,
                                            visible: true,
                                            rows: 3,
                                        },
                                    ],
                                },
                            ]}
                            addApiUrl="/api/Tarifa/SetTarifa"
                            deleteApiUrl="/api/Tarifa/DeleteTarifa"
                            loading={loading}
                            userCodAcceso={Number(user.codAcceso)}
                            userCodPerfil={Number(user.role)}
                        />
                    </div>
                );
            default:
                return null;
        }
    };

    return (
        <DetalleLayout
            title={gestor ? `Gestor ${gestor.nombre}` : "Cargando..."}
            backLink="/gestores"
            backText="Volver a Gestores"
            loading={loading}
            error={error}
            notFound={!gestor && !loading && !error}
            className="ficha-gestor"
        >
            {!loading && !error && gestor && (
                <div className="ficha-gestor__content">
                    <div className="ficha-gestor__section">
                        <div className="ficha-gestor__section-header">
                            <h2>Información General</h2>
                        </div>

                        <TabsNavigation
                            tabs={tabsGeneral}
                            activeTab={activeTabGeneral}
                            onTabChange={setActiveTabGeneral}
                            noBorderRadius={true}
                        />

                        <div className="ficha-gestor__section-content">
                            {renderGeneralContent()}
                        </div>
                    </div>

                    <div className="ficha-gestor__section">
                        <div className="ficha-gestor__section-header">
                            <h2>Datos del gestor</h2>
                        </div>

                        <TabsNavigation
                            tabs={tabsDatos}
                            activeTab={activeTabDatos}
                            onTabChange={setActiveTabDatos}
                            noBorderRadius={true}
                        />

                        <div className="ficha-gestor__section-content">
                            {renderDatosContent()}
                        </div>
                    </div>
                </div>
            )}
        </DetalleLayout>
    );
}
